export {default as Decor} from './Decor';

export {default as Grid} from './Grid';

export {default as Heading} from './Heading';

export {default as Input} from './Input';

export {default as Link} from './Link';

export {default as List} from './List';

export {default as MaxContentWidth} from './MaxContentWidth';

export {default as Page} from './Page';

export {default as Scroll} from './Scroll';

export {default as SeoWrapper} from './SeoWrapper';

// This is an empty export to add global styling and should not be used
export {default as Styles} from './Styles';

export {default as Text} from './Text';
